import logger from './logger';

export const API_TIMEOUT = 60000;
export const API_PREFIX = '/api';
export const API_VERSION = '/v1';

// Функция для логирования только в режиме разработки
const devLog = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

// Получаем initData из переменной окружения или от Telegram WebApp
export const getInitData = (): string => {
  const envInitData = process.env.REACT_APP_TMA_INIT_DATA;
  logger.log('REACT_APP_TMA_INIT_DATA:', envInitData);
  
  if (envInitData) {
    logger.log('Using env initData');
    return envInitData;
  }
  
  // Если переменная окружения не задана, используем реальную initData от Telegram
  const tgInitData = window.Telegram?.WebApp?.initData;
  logger.log('Telegram WebApp initData:', tgInitData);
  
  if (tgInitData) {
    logger.log('Using Telegram WebApp initData');
    return tgInitData;
  }
  
  logger.log('No initData available');
  // Если и Telegram WebApp недоступен, возвращаем пустую строку
  return '';
};

export const getBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:9909';
  return `${baseUrl}${API_PREFIX}${API_VERSION}`;
};

export const getToken = (): string => {
  // Получаем токен из localStorage или из initData Telegram
  const token = localStorage.getItem('token');
  if (token) {
    return token;
  }

  // Если токена нет в localStorage, пробуем получить из initData Telegram
  const initData = getInitData();
  if (initData) {
    try {
      const params = new URLSearchParams(initData);
      const user = params.get('user');
      if (user) {
        const userData = JSON.parse(user);
        return userData.id.toString();
      }
    } catch (error) {
      logger.error('Ошибка при парсинге initData:', error);
    }
  }

  return '';
};
